import { useAiPromo } from './use-ai-promo';
import { AiService } from 'types';
import { Dialog, message, VStack } from 'components/ui';
import { AiPromoContent } from './ui/ai-promo-content';

type AiPromoProps<T extends AiService> = {
  dialogTitle: string;
  open: boolean;
  onClose: () => void;
  apiService: T;
};

export const AiPromo = <T extends AiService>(props: AiPromoProps<T>) => {
  const { dialogTitle, open, onClose, apiService } = props;
  const { phase, submit, check } = useAiPromo({ open, apiService });

  const handleSubmit = async () => {
    const success = await submit();

    if (success) {
      message({ type: 'success', text: 'Запрос отправлен' });
      onClose();
    }
  };

  return (
    <Dialog.Root open={open} onOpenChange={(v) => !v && onClose()}>
      <Dialog.Portal>
        <Dialog.Content>
          <Dialog.Panel style={{ width: 650 }}>
            <VStack padding={16} spacing="base">
              <Dialog.Description hidden>
                Промо модальное окно для ИИ-редактора
              </Dialog.Description>

              <AiPromoContent
                dialogTitle={dialogTitle}
                phase={phase}
                onClose={onClose}
                onSubmit={handleSubmit}
                handleRetry={check}
              />
            </VStack>
          </Dialog.Panel>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
